import React from "react";
import styles from "./Destinations6.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations6 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <div className={styles.topLine}></div>
        <h2 className={styles.title}>
          The <span>Travel</span> Edit
        </h2>
        <p className={styles.lead}>
          A curated selection of the world's most silent retreats
        </p>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.track}>
          {scrollItems.map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.imageBox}>
                  <img
                    src={imageUrl}
                    alt={dest?.name || "Destination"}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = fallbackImage;
                    }}
                  />

                  <div className={styles.verticalLabel}>
                    Special Edition
                  </div>
                </div>

                <div className={styles.details}>
                  <span className={styles.country}>Destination</span>

                  <h3 className={styles.cardTitle}>
                    {dest?.name || "Explore Destination"}
                  </h3>

                  <div className={styles.action}>
                    <span className={styles.plus}>+</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations6;